import React, { ReactNode } from 'react';
import classNames from 'classnames';

interface Props {
  children: ReactNode;
  centered?: boolean;
}

function PillMenu({ children, centered }: Props) {
  return (
    <div
      className={classNames(
        'flex flex-1 flex-wrap gap-2 md:gap-7',
        centered && 'items-center justify-center'
      )}
    >
      {children}
    </div>
  );
}

export default PillMenu;
